'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _Icon = require('./Icon.style');

var _Icon2 = _interopRequireDefault(_Icon);

var _utils = require('../utils/utils');

var _utils2 = _interopRequireDefault(_utils);

var _Add = require('./img/Add');

var _Add2 = _interopRequireDefault(_Add);

var _Archive = require('./img/Archive');

var _Archive2 = _interopRequireDefault(_Archive);

var _Arrow = require('./img/Arrow');

var _Arrow2 = _interopRequireDefault(_Arrow);

var _Arrows = require('./img/Arrows');

var _Arrows2 = _interopRequireDefault(_Arrows);

var _ArrowStat = require('./img/ArrowStat');

var _ArrowStat2 = _interopRequireDefault(_ArrowStat);

var _Attach = require('./img/Attach');

var _Attach2 = _interopRequireDefault(_Attach);

var _Calendar = require('./img/Calendar');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _Camera = require('./img/Camera');

var _Camera2 = _interopRequireDefault(_Camera);

var _Check = require('./img/Check');

var _Check2 = _interopRequireDefault(_Check);

var _CheckBox = require('./img/CheckBox');

var _CheckBox2 = _interopRequireDefault(_CheckBox);

var _CheckboxOff = require('./img/CheckboxOff');

var _CheckboxOff2 = _interopRequireDefault(_CheckboxOff);

var _CheckboxOn = require('./img/CheckboxOn');

var _CheckboxOn2 = _interopRequireDefault(_CheckboxOn);

var _Clock = require('./img/Clock');

var _Clock2 = _interopRequireDefault(_Clock);

var _Close = require('./img/Close');

var _Close2 = _interopRequireDefault(_Close);

var _Comment = require('./img/Comment');

var _Comment2 = _interopRequireDefault(_Comment);

var _Channels = require('./img/Channels');

var _Channels2 = _interopRequireDefault(_Channels);

var _ContactUs = require('./img/ContactUs');

var _ContactUs2 = _interopRequireDefault(_ContactUs);

var _Dashboard = require('./img/Dashboard');

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _Delete = require('./img/Delete');

var _Delete2 = _interopRequireDefault(_Delete);

var _Diagram = require('./img/Diagram');

var _Diagram2 = _interopRequireDefault(_Diagram);

var _Document = require('./img/Document');

var _Document2 = _interopRequireDefault(_Document);

var _Dog = require('./img/Dog');

var _Dog2 = _interopRequireDefault(_Dog);

var _Dropdown = require('./img/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _Edit = require('./img/Edit');

var _Edit2 = _interopRequireDefault(_Edit);

var _Exit = require('./img/Exit');

var _Exit2 = _interopRequireDefault(_Exit);

var _Eye = require('./img/Eye');

var _Eye2 = _interopRequireDefault(_Eye);

var _Files = require('./img/Files');

var _Files2 = _interopRequireDefault(_Files);

var _Graph = require('./img/Graph');

var _Graph2 = _interopRequireDefault(_Graph);

var _Hash = require('./img/Hash');

var _Hash2 = _interopRequireDefault(_Hash);

var _Hide = require('./img/Hide');

var _Hide2 = _interopRequireDefault(_Hide);

var _Hierarchy = require('./img/Hierarchy');

var _Hierarchy2 = _interopRequireDefault(_Hierarchy);

var _Key = require('./img/Key');

var _Key2 = _interopRequireDefault(_Key);

var _Link = require('./img/Link');

var _Link2 = _interopRequireDefault(_Link);

var _List = require('./img/List');

var _List2 = _interopRequireDefault(_List);

var _CleverLeaf = require('./img/CleverLeaf');

var _CleverLeaf2 = _interopRequireDefault(_CleverLeaf);

var _Client = require('./img/Client');

var _Client2 = _interopRequireDefault(_Client);

var _Mail = require('./img/Mail');

var _Mail2 = _interopRequireDefault(_Mail);

var _Maxsize = require('./img/Maxsize');

var _Maxsize2 = _interopRequireDefault(_Maxsize);

var _Message = require('./img/Message');

var _Message2 = _interopRequireDefault(_Message);

var _Microphone = require('./img/Microphone');

var _Microphone2 = _interopRequireDefault(_Microphone);

var _Minimize = require('./img/Minimize');

var _Minimize2 = _interopRequireDefault(_Minimize);

var _More = require('./img/More');

var _More2 = _interopRequireDefault(_More);

var _Mute = require('./img/Mute');

var _Mute2 = _interopRequireDefault(_Mute);

var _NoEye = require('./img/NoEye');

var _NoEye2 = _interopRequireDefault(_NoEye);

var _Notification = require('./img/Notification');

var _Notification2 = _interopRequireDefault(_Notification);

var _PersonAdd = require('./img/PersonAdd');

var _PersonAdd2 = _interopRequireDefault(_PersonAdd);

var _Persons = require('./img/Persons');

var _Persons2 = _interopRequireDefault(_Persons);

var _Plus = require('./img/Plus');

var _Plus2 = _interopRequireDefault(_Plus);

var _Process = require('./img/Process');

var _Process2 = _interopRequireDefault(_Process);

var _QuestionMark = require('./img/QuestionMark');

var _QuestionMark2 = _interopRequireDefault(_QuestionMark);

var _RadioOff = require('./img/RadioOff');

var _RadioOff2 = _interopRequireDefault(_RadioOff);

var _RadioOn = require('./img/RadioOn');

var _RadioOn2 = _interopRequireDefault(_RadioOn);

var _Reject = require('./img/Reject');

var _Reject2 = _interopRequireDefault(_Reject);

var _Repeat = require('./img/Repeat');

var _Repeat2 = _interopRequireDefault(_Repeat);

var _Search = require('./img/Search');

var _Search2 = _interopRequireDefault(_Search);

var _Send = require('./img/Send');

var _Send2 = _interopRequireDefault(_Send);

var _Settings = require('./img/Settings');

var _Settings2 = _interopRequireDefault(_Settings);

var _SideView = require('./img/SideView');

var _SideView2 = _interopRequireDefault(_SideView);

var _Sign = require('./img/Sign');

var _Sign2 = _interopRequireDefault(_Sign);

var _Smile = require('./img/Smile');

var _Smile2 = _interopRequireDefault(_Smile);

var _StarEmpty = require('./img/StarEmpty');

var _StarEmpty2 = _interopRequireDefault(_StarEmpty);

var _StarFull = require('./img/StarFull');

var _StarFull2 = _interopRequireDefault(_StarFull);

var _Stream = require('./img/Stream');

var _Stream2 = _interopRequireDefault(_Stream);

var _Trash = require('./img/Trash');

var _Trash2 = _interopRequireDefault(_Trash);

var _Picture = require('./img/Picture');

var _Picture2 = _interopRequireDefault(_Picture);

var _TypeGroup = require('./img/TypeGroup');

var _TypeGroup2 = _interopRequireDefault(_TypeGroup);

var _TypeSingle = require('./img/TypeSingle');

var _TypeSingle2 = _interopRequireDefault(_TypeSingle);

var _Wallet = require('./img/Wallet');

var _Wallet2 = _interopRequireDefault(_Wallet);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var __TYPES__ = {
  Add: _Add2["default"],
  Archive: _Archive2["default"],
  Arrow: _Arrow2["default"],
  Arrows: _Arrows2["default"],
  ArrowStat: _ArrowStat2["default"],
  Attach: _Attach2["default"],
  Calendar: _Calendar2["default"],
  Camera: _Camera2["default"],
  Check: _Check2["default"],
  CheckBox: _CheckBox2["default"],
  CheckboxOff: _CheckboxOff2["default"],
  CheckboxOn: _CheckboxOn2["default"],
  Clock: _Clock2["default"],
  Close: _Close2["default"],
  Comment: _Comment2["default"],
  Channels: _Channels2["default"],
  ContactUs: _ContactUs2["default"],
  Dashboard: _Dashboard2["default"],
  Delete: _Delete2["default"],
  Diagram: _Diagram2["default"],
  Document: _Document2["default"],
  Dog: _Dog2["default"],
  Dropdown: _Dropdown2["default"],
  Edit: _Edit2["default"],
  Exit: _Exit2["default"],
  Eye: _Eye2["default"],
  Files: _Files2["default"],
  Graph: _Graph2["default"],
  Hash: _Hash2["default"],
  Hide: _Hide2["default"],
  Hierarchy: _Hierarchy2["default"],
  Key: _Key2["default"],
  Link: _Link2["default"],
  List: _List2["default"],
  CleverLeaf: _CleverLeaf2["default"],
  Client: _Client2["default"],
  Mail: _Mail2["default"],
  Maxsize: _Maxsize2["default"],
  Message: _Message2["default"],
  Microphone: _Microphone2["default"],
  Minimize: _Minimize2["default"],
  More: _More2["default"],
  Mute: _Mute2["default"],
  NoEye: _NoEye2["default"],
  Notification: _Notification2["default"],
  PersonAdd: _PersonAdd2["default"],
  Persons: _Persons2["default"],
  Plus: _Plus2["default"],
  Process: _Process2["default"],
  RadioOff: _RadioOff2["default"],
  RadioOn: _RadioOn2["default"],
  Reject: _Reject2["default"],
  Repeat: _Repeat2["default"],
  Search: _Search2["default"],
  Send: _Send2["default"],
  Stream: _Stream2["default"],
  Settings: _Settings2["default"],
  SideView: _SideView2["default"],
  Sign: _Sign2["default"],
  Smile: _Smile2["default"],
  Picture: _Picture2["default"],
  QuestionMark: _QuestionMark2["default"],
  StarEmpty: _StarEmpty2["default"],
  StarFull: _StarFull2["default"],
  Trash: _Trash2["default"],
  TypeGroup: _TypeGroup2["default"],
  TypeSingle: _TypeSingle2["default"],
  Wallet: _Wallet2["default"]
};
var Icon = (_dec = (0, _reactJss2["default"])(_Icon2["default"], {
  inject: ['classes', 'sheet']
}), _dec(_class = function (_PureComponent) {
  (0, _inherits3["default"])(Icon, _PureComponent);

  function Icon(props, context) {
    (0, _classCallCheck3["default"])(this, Icon);

    var _this = (0, _possibleConstructorReturn3["default"])(this, (Icon.__proto__ || (0, _getPrototypeOf2["default"])(Icon)).call(this, props, context));

    _this.state = {
      instanceId: _utils2["default"].random(),
      colorRule: null
    };
    return _this;
  }

  (0, _createClass3["default"])(Icon, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      this.changeColor(this.props.color);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this._isMounted) return;
      this.changeColor(nextProps.color);
    } // Icon change color

  }, {
    key: 'changeColor',
    value: function changeColor(color) {
      if (!color) return;
      var sheet = this.props.sheet;
      var instanceId = this.state.instanceId;
      var colorRule = sheet.addRule(instanceId, {
        '& .fill': {
          fill: color
        },
        '& .stroke': {
          stroke: color
        }
      });
      this.setState({
        colorRule: colorRule
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var type = this.props.type;
      var _state = this.state,
          colorRule = _state.colorRule,
          instanceId = _state.instanceId;

      var IconComp = __TYPES__[_utils2["default"].toPascalCase(type)];

      var _props = this.props,
          classes = _props.classes,
          size = _props.size,
          className = _props.className,
          id = _props.id,
          onClick = _props.onClick,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          error = _props.error,
          visibility = _props.visibility,
          forwardRef = _props.forwardRef;
      var colorRuleClass = colorRule ? colorRule.options.classes[instanceId] : null;
      return _react2["default"].createElement('i', {
        id: id,
        className: (0, _bind2["default"])(className, classes.wrap, classes[size]),
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ref: forwardRef
      }, IconComp ? _react2["default"].createElement(IconComp, {
        className: (0, _bind2["default"])(classes[size], classes.icon, colorRuleClass, {
          error: !!error
        }, {
          hidden: visibility === 'hidden'
        }, {
          disabled: visibility === 'disabled'
        })
      }) : '');
    }
  }]);
  return Icon;
}(_react.PureComponent)) || _class);
Icon.defaultProps = {
  size: 'medium',
  visibility: 'visible',
  error: false,
  onClick: function onClick() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
};
Icon.propTypes = {
  classes: _propTypes2["default"].object,
  sheet: _propTypes2["default"].object,

  /** icon's type */
  type: _propTypes2["default"].string.isRequired,

  /** icon's size */
  size: _propTypes2["default"].oneOf(['micro', 'small', 'medium', 'large', 'xlarge']),

  /** icon's visibility */
  visibility: _propTypes2["default"].oneOf(['visible', 'disabled', 'hidden']),

  /** Does icon has an error */
  error: _propTypes2["default"].bool,

  /** icon's custom color */
  color: _propTypes2["default"].string,

  /** additional external class name */
  className: _propTypes2["default"].string,

  /** element id */
  id: _propTypes2["default"].string,

  /** callback onClick */
  onClick: _propTypes2["default"].func,

  /** callback onMouseEnter */
  onMouseEnter: _propTypes2["default"].func,

  /** callback onMouseLeave */
  onMouseLeave: _propTypes2["default"].func,

  /** Use that property to pass a ref callback to the native input component. */
  forwardRef: _propTypes2["default"].func
};
exports["default"] = Icon;